import React from 'react'
import { View, StyleSheet } from 'react-native'
import { createStackNavigator } from '@react-navigation/stack'
import { HeaderBackButton } from '@react-navigation/elements'

import { backgroundColors, colors, theme } from '@sart/styles'
import Checkout from './Checkout'
import CheckoutPayment from './CheckoutPayment'
import CheckoutHostedPayment from './CheckoutHostedPayment'
import CheckoutConfirmation from './CheckoutConfirmation'
import CheckoutUpdateReceipt from './CheckoutUpdateReceipt'
import CheckoutCashProcessing from './CheckoutCashProcessing'
import CheckoutProcessing from './CheckoutProcessing'
import Confirmation from '../Confirmation'

import { useContent } from '@sart/content'

const Stack = createStackNavigator()

export function CheckoutNavigationStacks() {

  const content = useContent()

  return (
    <Stack.Navigator
      initialRouteName='Checkout'
      screenOptions={{
        headerShown:false
      }}
    >
      <Stack.Screen
        name="Checkout"
        component={Checkout}
        options={{
          title: content.navigation.checkout,
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0
          },
          headerRight: () => (<View/>),
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              tintColor={colors.srGreen}
            />
          )
        }}
      />
      <Stack.Screen
        name="Payment"
        component={CheckoutPayment}
        options={{
          title: content.navigation.payment,
          headerTitleStyle: theme.navigationHeader,
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0
          },
          headerRight: () => (<View/>),
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              tintColor={colors.srGreen}
            />
          )
        }}
      />
      <Stack.Screen
        name="Receipt"
        component={CheckoutUpdateReceipt}
        options={{
          title: content.navigation.receipt,
          headerTitleStyle: theme.navigationHeaderUpdateReciept,
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0
          },
          headerRight: () => (<View/>),
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              tintColor={colors.srGreen}
            />
          )
        }}
      />
      <Stack.Screen
        name="Confirmation"
        component={Confirmation}
        options={{
          title: '',
          headerTitleStyle: theme.navigationHeader,
          headerRight: () => (<View/>),
          headerStyle: {
            backgroundColor: backgroundColors.white,
            borderBottomWidth: 0,
            elevation: 0
          },
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              tintColor={colors.srGreen}
            />
          )
        }}
      />
      <Stack.Screen
        name="CheckoutConfirmation"
        component={CheckoutConfirmation}
        options={{
          title: '',
          headerTitleStyle: theme.navigationHeader,
          headerRight: () => (<View/>),
          headerStyle: {
            backgroundColor: backgroundColors.white,
            borderBottomWidth: 0,
            elevation: 0
          },
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              tintColor={colors.srGreen}
            />
          )
        }}
      />
      <Stack.Screen
        name="ProcessingCash"
        component={CheckoutCashProcessing}
        options={({ navigation }) => ({
          title: content.navigation.confirmation,
          headerTitleStyle: theme.navigationHeaderPlan,
          headerStyle: {
            backgroundColor: backgroundColors.white,
            borderBottomWidth: 0,
            elevation: 0
          },
          headerRight: () => (<View/>),
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              label={content.navigation.dashboard}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Dashboard')
              }}
              tintColor={colors.srGreen}
            />
          )
        })}
      />
      <Stack.Screen
        name="HostedPayment"
        component={CheckoutHostedPayment}
        options={{
          title: content.navigation.payment,
          headerTitleStyle: theme.navigationHeader,
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0
          },
          headerRight: () => (<View/>)
        }}
      />
      <Stack.Screen
        name="CheckoutProcessing"
        component={CheckoutProcessing}
        options={{
          title: "",
          headerTitleStyle: theme.navigationHeaderProcessing,
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0,
            backgroundColor: colors.srGreen
          },
          headerLeft: null
        }}
      />
    </Stack.Navigator>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: colors.white,
    paddingBottom: 0
  },
  view: {
    // flex: 1,
    backgroundColor: 'red'
  }
})